<template>
  <ModalComponent :show="show" @close="$emit('cancel')" class="confirm-dialog">
    <Card theme="flat">
      <template #header>
        <FontAwesomeIcon :icon="icon" size="2x" />
        <strong class="mt-1">{{ title }}</strong>
      </template>
      <template #default>
        <p>{{ message }}</p>
      </template>
      <template #footer>
        <ButtonComponent :label="cancelLabel || $t('cancel')" :icon="['fal', 'times']" @click="$emit('cancel')" />
        <ButtonComponent
          :theme="theme"
          :label="confirmLabel || $t('confirm')"
          :icon="confirmIcon"
          @click="$emit('confirm')"
        />
      </template>
    </Card>
  </ModalComponent>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'
import { ModalComponent } from 'vue-elder-modal'
import Card from '@/components/Card'

export default {
  props: {
    show: Boolean,
    title: String,
    message: String,
    confirmLabel: String,
    cancelLabel: String,
    theme: {
      type: String,
      default: 'error',
    },
    icon: {
      type: Array,
      default: () => ['fal', 'exclamation-triangle'],
    },
    confirmIcon: {
      type: Array,
      default: () => ['fal', 'check'],
    },
  },
  components: {
    ButtonComponent,
    ModalComponent,
    Card,
  },
}
</script>

<style lang="scss">
.confirm-dialog {
  .card__footer-content {
    justify-content: flex-end;
  }
}
</style>
